export function Executor(props) {
  var data = props.hook();
  props.onUpdate(data);
  return null;
}